/**
 * 2026-04-25 Phase 32-C.3 — 결정 직전 완전 암전 0.3초.
 *
 * 확정 버튼 클릭 → 결과 연출 사이에 끼워 숨 멎는 순간 연출.
 * onComplete 콜백으로 다음 단계 트리거.
 */
import { useEffect } from "react";
import { motion } from "framer-motion";

interface Props {
    /** 암전 종료 후 호출 (0.3초). */
    onComplete?: () => void;
    /** 암전 시간 ms. 기본 300. */
    durationMs?: number;
}

export function BlackoutFlash({ onComplete, durationMs = 300 }: Props) {
    useEffect(() => {
        const id = setTimeout(() => onComplete?.(), durationMs);
        return () => clearTimeout(id);
    }, [onComplete, durationMs]);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.05 }}
            style={{
                position: "fixed",
                inset: 0,
                background: "radial-gradient(circle at center, rgba(0,0,0,0.72) 0%, #000 62%)",
                zIndex: 4000,
                pointerEvents: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
            aria-hidden
        >
            <motion.div
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: [0, 0.78, 0.4], scale: [0.96, 1, 1] }}
                transition={{ duration: Math.max(durationMs / 1000, 0.3), times: [0, 0.45, 1] }}
                style={{
                    color: "rgba(240,228,202,0.85)",
                    fontFamily: "serif",
                    fontSize: 18,
                    letterSpacing: "0.18em",
                    textShadow: "0 2px 8px rgba(0,0,0,0.9), 0 0 16px rgba(0,0,0,0.9)",
                }}
            >
                숨을 죽인다
            </motion.div>
        </motion.div>
    );
}
